<template>
    <div class="homecontainer _homecontainer">
        <!-- <GoodBriefInfo
            :goodname="''"
            :goodinfo="'开运红绳,吉祥好意头'"
            :fontcolor="'black'"
            :backgoundcolor="'rgb(19, 18, 25)'"
            :imgsrc="require('./imgs/p1.jpg')"
        />
        <GoodBriefInfo
            :goodname="''"
            :goodinfo="'旺缘红绳手链'"
            :fontcolor="'white'"
            :backgoundcolor="'rgb(250, 250, 250)'"
            :imgsrc="require('./imgs/p2.jpg')"
        />
        <GoodBriefInfo
            :goodname="''"
            :goodinfo="'一品茶香,福寿无疆'"
            :fontcolor="'white'"
            :backgoundcolor="'rgb(250, 250, 250)'"
            :imgsrc="require('./imgs/p3.jpg')"
        />
        <div class="subdiv _subdiv">
            <div class="left">
                <GoodBriefInfo
                    :goodname="''"
                    :goodinfo="'大境人生，典藏古玩'"
                    :backgoundcolor="'rgb(250, 250, 250)'"
                    :fontcolor="'white'"
                    :imgsrc="require('./imgs/p4.jpg')"
                />
            </div>
            <div class="right">
                <GoodBriefInfo
                    :goodname="''"
                    :goodinfo="'翰墨寄真情，丹青颂伟人'"
                    :fontcolor="'white'"
                    :backgoundcolor="'rgb(19, 18, 25)'"
                    :imgsrc="require('./imgs/p5.jpg')"
                />
            </div>
        </div>
        <div class="subdiv _subdiv">
            <div class="left">
                <GoodBriefInfo
                    :goodname="''"
                    :goodinfo="'超凡品质，尽显奢华'"
                    :backgoundcolor="'rgb(0, 0, 0)'"
                    :fontcolor="'white'"
                    :imgsrc="require('./imgs/p6.jpg')"
                />
            </div>
            <div class="right">
                <GoodBriefInfo
                    :goodname="''"
                    :goodinfo="'豪庭雅苑，华都相伴'"
                    :fontcolor="'white'"
                    :backgoundcolor="'rgb(251, 251, 253)'"
                    :imgsrc="require('./imgs/p7.jpg')"
                />
            </div>
        </div> -->
        <div class="wrap">
            <div class="topBig">
                <div class="photo">
                    <img src="../../assets/未标题-1.jpg" alt="" />
                </div>
                <div class="intro">APP首页找房<br /></div>
            </div>

            <div class="topBig">
                <div class="intro" style="padding-right: 20px">
                    求租列表
                </div>
                <div class="photo">
                    <img src="../../assets/9.jpg" alt="" />
                </div>
            </div>
			<div class="topBig">
			    <div class="intro" style="padding-right: 20px">
			        整租列表
			    </div>
			    <div class="photo">
			        <img src="../../assets/11.jpg" alt="" />
			    </div>
			</div>
            <!-- 宫格 -->
            <div class="grie">
                <div class="itemBox">
                    <div class="photo"><img src="../../assets/12.jpg" alt="" /></div>
                    <div class="intro"> 上传租房信息</div>
                </div>
                <div class="itemBox">
                    <div class="photo"><img src="../../assets/3.jpg" alt="" /></div>
                    <div class="intro">我上传的房屋信息</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GoodBriefInfo from './subcomponents/GoodBriefInfo';

export default {
    name: '',
    components: {
        GoodBriefInfo,
    },
};
</script>

<style lang="less" scoped>
// 大于800px
@media only screen and (min-width: 800px) {
    .homecontainer {
        font-size: 1vw;
        .wrap {
            width: 80%;
            margin: 0 auto;
            .topBig {
                width: 100%;
                background-color: #333;
                padding: 20px 50px;
                box-sizing: border-box;
                display: flex;
                margin-top: 1px;
                .photo {
                    width: 30%;
                    height: 100%;
                    overflow: hidden;
                    img {
                        width: 100%;
                        transition: all 0.5s;
                    }
                    &:hover img {
                        transform: scale(1.1);
                    }
                }
                .intro {
                    width: 70%;
                    padding-top: 100px;
                    text-align: center;
                    color: #fff;
                    font-size: 40px;
                    line-height: 80px;
                }
            }
            .grie {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                .itemBox {
                    width: 49%;
                    margin-top: 20px;
                    background-color: #333;
                    box-sizing: border-box;
                    padding: 20px;
                    display: flex;
                    .photo {
                        width: 30%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            transition: all 0.5s;
                        }
                        &:hover img {
                            transform: scale(1.1);
                        }
                    }
                    .intro {
                        width: 70%;
                        text-align: center;
                        color: #fff;
                        font-size: 30px;
                        line-height: 70px;
                        padding: 10px;
                    }
                }
            }
        }
    }
}

// 小于800px
@media only screen and (max-width: 800px) {
    ._homecontainer {
        font-size: 1vw;
        .wrap {
            width: 100%;
            margin: 0 auto;
            .topBig {
                width: 100%;
                background-color: #333;
                .photo {
                    width: 20%;
                    height: 100%;
                    margin: 0 auto;
                    img {
                        width: 100%;
                        transition: all 0.5s;
                    }
                    &:hover img {
                        transform: scale(1.1);
                    }
                }
                .intro {
                    width: 100%;
                    text-align: center;
                    color: #fff;
                    padding: 20px 0;
                }
            }
            .grie {
                width: 100%;
                .itemBox {
                    width: 100%;
                    margin-top: 20px;
                    background-color: #333;
                    box-sizing: border-box;
                    padding: 20px;
                    display: flex;
                    .photo {
                        width: 30%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            transition: all 0.5s;
                        }
                        &:hover img {
                            transform: scale(1.1);
                        }
                    }
                    .intro {
                        width: 70%;
                        text-align: center;
                        color: #fff;
                        font-size: 25px;
                        line-height: 50px;
                        padding: 10px;
                    }
                }
            }
        }
    }
}
</style>
